import Image from "next/image";
import Link from "next/link";
import styles from "./NavBar.module.css";
import Menu from "@/parent-components/NavBar/Menu";
import aldar from "@/assets/images2/aldar.svg";
import close from "../../assets/icons/cancel-btn.svg";
import Profile from "../Profile";

const NavBar = (props) => {
  
const navigation = props?.data?.navigation;
const profile = props?.data?.profile;
const logo = props?.data?.logo?.[0]?.fileUrl;
const mobilelogo = props?.data?.mobilelogo?.[0]?.fileUrl;
const logoLink = props?.data?.logoLink;

  return (
    <nav
      className="navbar navbar-expand-lg navbar-light py-4"
      data-testid="navbar-container-id"
    >
      <span className={styles.contact_link}>
        <Profile data={profile} />
      </span>

      <button
        className="navbar-toggler"
        type="button"
        data-bs-toggle="collapse"
        data-bs-target="#navbarTogglerDemo02"
        aria-controls="navbarTogglerDemo02"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <span className="navbar-toggler-icon"></span>
      </button>
      <Link
        className="navbar-brand d-block d-lg-none me-0"
        href={logoLink || "#"}
      >
        {logo && (
          <Image
            src={logo}
            alt="logo"
            width={149}
            height={40}
            sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
          />
        )}
      </Link>
      <div
        className="collapse navbar-collapse ms-0 ms-lg-5"
        // className={`collapse navbar-collapse ${ !isMobileDevice && 'show'} ms-0 ms-lg-5`}
        id="navbarTogglerDemo02"
        // onClick={handleShow}
      >
        <button
          className="navbar-toggler close"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarTogglerDemo02"
          aria-controls="navbarTogglerDemo02"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <Image
            src={close}
            alt="call"
            width={24}
            height={24}
            sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
          />
        </button>
        <Menu menuData={navigation} sublink={false} />
      </div>
      <form className="d-none d-lg-block">
        <Link className="navbar-brand d-none d-lg-block" href={logoLink || "#"}>
          {logo && (
            <Image
              src={logo}
              alt="logo"
              width={149}
              height={40}
              sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
            />
          )}
        </Link>
      </form>
    </nav>
  );
};

export default NavBar;
